import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-text-justification',
  templateUrl: './text-justification.component.html',
  styleUrls: ['./text-justification.component.css']
})
export class TextJustificationComponent implements OnInit {
  ngOnInit(): void {      
  }
  onSubmit() {

  }
}
